import { render, staticRenderFns } from "./BotManageTextPosts.vue?vue&type=template&id=0ed61020&"
import script from "./BotManageTextPosts.vue?vue&type=script&lang=js&"
export * from "./BotManageTextPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports